import React from "react";

// reactstrap components
import {
  Alert,
  Button,
  Card,
  CardHeader,
  Col,
  FormGroup,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  CardFooter,
  Pagination,
  PaginationItem,
  PaginationLink,
  Container,
  Row,
} from "reactstrap";
// core components
import ReactDatetime from "react-datetime";
import * as moment from "moment";
import CheckoutHistories from "components/Tables/CheckoutHistory";
import Modal from "components/Modals/CheckoutHistory";
import Header from "components/Headers/CheckoutHistoryHeader";
import DeductDataService from "../../services/DeductDataService";
import CreditDataService from "../../services/CreditDataService";

class CheckoutHistory extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      defaultModal: false,
      checkouts: [],
      perPage: 10,
      currentPage: 1,
      currentCheckout: {},
    };
    this.DeductDataService = new DeductDataService();
    this.creditDataService = new CreditDataService();
  }
  
  toggleModal = (state, formType, checkout) => {
    this.setState({
      [state]: !this.state[state],
      formType: formType,
      currentCheckout: checkout,
    });
  };

  componentDidMount() {
    this.fetchData()
  }

  onDateChanged(e, dateFieldType) {
    var date = new Date(e._d);
    if (dateFieldType === 'endDate') {
        date.setHours(23, 59, 59, 59);
    } else {
      date.setHours(0, 0, 0, 0);
    }
    this.setState({
          [dateFieldType] : moment(date.toISOString(), 'YYYY-MM-DDTHH:mm:ss.sssZ').format('YYYY-MM-DD hh:mm:ss'),
          currentPage: 1,
    }, () => {
        this.fetchData();
    });
  }

  onReset() {
    window.location.reload();
  }

  downloadDailyReport() {
    if (this.state.startDate === undefined || this.state.endDate === undefined) {
      this.setState({ 'errorMessage': 'Tanggal harus diisi.'})
      setTimeout(() => {
        this.setState({ errorMessage: undefined })
      }, 5000);
      return;
    }
    this.creditDataService.exportDailyReport(
      this.state.startDate, this.state.endDate
    ).catch(err => {
      this.setState({ 'errorMessage': err})
      setTimeout(() => {
        this.setState({ errorMessage: undefined })
      }, 5000);
    })
  }
  
  fetchData() {
    let dateRange = [this.state.startDate, this.state.endDate];
    this.DeductDataService
      .getList(dateRange, this.state.currentPage, this.state.perPage)
      .then(res => this.setState(res));
  }

  handlePageClick = (e) => {
    const selectedPage = e;

    this.setState({
        currentPage: selectedPage,
    }, () => {
      this.fetchData()
    });
  }

  handleNextPageClick() {
    this.handlePageClick(this.state.currentPage + 1)
  }

  handlePreviousPageClick() {
    this.handlePageClick(this.state.currentPage - 1)
  }

  setSuccessMessage = (message) => {
    this.setState({ successMessage: message})
    setTimeout(() => {
      this.setState({ successMessage: undefined })
    }, 5000);
  }

  setErrorMessage = (message) => {
    this.setState({ errorMessage: message })
    setTimeout(() => {
      this.setState({ errorMessage: undefined })
    }, 5000);
  }

  render() {
    const pageNumbers = [];
    for (var index = 1; index <= this.state.totalPages; index++) {
      pageNumbers.push(index)
    }

    const MAX_PAGES_DISPLAYED = 10; // Define the maximum number of page numbers to display at once
    const { currentPage, totalPages } = this.state;

    // Calculate the range of page numbers to display
    const startPage = Math.max(currentPage - Math.floor(MAX_PAGES_DISPLAYED / 2), 1);
    const endPage = Math.min(startPage + MAX_PAGES_DISPLAYED - 1, totalPages);

    // Include the minimum and maximum page numbers
    const minPage = 1;
    const maxPage = totalPages;

    const pageNumbersToDisplay = [];

    // Add the minimum page number if it's not in the range
    if (minPage < startPage) {
      pageNumbersToDisplay.push(minPage);
    }

    // Add ellipsis if there's a gap between the minimum page and the start of the range
    if (startPage > minPage) {
      pageNumbersToDisplay.push('...');
    }

    // Add the page numbers within the range
    for (let i = startPage; i <= endPage; i++) {
      pageNumbersToDisplay.push(i);
    }

    // Add ellipsis if there's a gap between the range and the maximum page
    if (endPage < maxPage) {
      pageNumbersToDisplay.push('...');
    }

    // Add the maximum page number if it's not in the range
    if (maxPage > endPage) {
      pageNumbersToDisplay.push(maxPage);
    }

    const renderPageNumbers =
    (
      <div>
        <ul className="pagination">
          {pageNumbersToDisplay.map(number => (
            <PaginationItem key={number} className={currentPage === number ? "active" : ""}>
              {number === '...' ? (
                <PaginationLink disabled>{number}</PaginationLink>
              ) : (
                <PaginationLink onClick={() => this.handlePageClick(number)}>
                  {number}
                </PaginationLink>
              )}
            </PaginationItem>
          ))}
        </ul>
      </div>
    );
    
    return (
      <>
        <Header />
        {/* Page content */}
        <Container className="mt--7" fluid>
          {/* Table */}
          <Row>
            <div className="col">
              <Card className="shadow">
                <CardHeader className="border-0">
                  <Row className="align-items-center">
                    <Col className="text-right" xs="4">
                      <Modal
                        toggleModal={() => this.toggleModal("formModal")}
                        formModal={this.state.formModal}
                        formType={this.state.formType}
                        currentCheckout={this.state.currentCheckout}
                        setSuccessMessage={this.setSuccessMessage}
                        fetchData={this.fetchData.bind(this)}
                      />
                    </Col>
                    {this.state.successMessage && (
                      <Col xs="12" className="mt-5">
                        <Alert color="success">
                          {this.state.successMessage}
                        </Alert>
                      </Col>
                    )}
                    {this.state.errorMessage && (
                      <Col xs="12" className="mt-5">
                        <Alert color="danger">
                          {this.state.errorMessage}
                        </Alert>
                      </Col>
                    )}
                  </Row>
                  <Row className="mt-3">
                      <Col xs={6}>
                        <Row>
                            <Col xs={4}>
                                <FormGroup>
                                <InputGroup className="input-group-alternative">
                                    <InputGroupAddon addonType="prepend">
                                    <InputGroupText>
                                        <i className="ni ni-calendar-grid-58" />
                                    </InputGroupText>
                                    </InputGroupAddon>
                                    <ReactDatetime
                                    inputProps={{
                                        placeholder: "Dari tanggal"
                                    }}
                                    range="start"
                                    timeFormat={false}
                                    renderDay={(props, currentDate, selectedDate) => {
                                        let classes = props.className;
                                        if (
                                        this.state.startDate &&
                                        this.state.endDate &&
                                        this.state.startDate._d + "" === currentDate._d + ""
                                        ) {
                                        classes += " start-date";
                                        } else if (
                                        this.state.startDate &&
                                        this.state.endDate &&
                                        new Date(this.state.startDate._d + "") <
                                            new Date(currentDate._d + "") &&
                                        new Date(this.state.endDate._d + "") >
                                            new Date(currentDate._d + "")
                                        ) {
                                        classes += " middle-date";
                                        } else if (
                                        this.state.endDate &&
                                        this.state.endDate._d + "" === currentDate._d + ""
                                        ) {
                                        classes += " end-date";
                                        }
                                        return (
                                        <td {...props} className={classes}>
                                            {currentDate.date()}
                                        </td>
                                        );
                                    }}
                                    onChange={(e) => this.onDateChanged(e, "startDate")}
                                    // onChange={e => this.setState({ startDate: e })}
                                    />
                                </InputGroup>
                                </FormGroup>
                            </Col>
                            <Col xs={4} className="ml-n4">
                                <FormGroup>
                                <InputGroup className="input-group-alternative">
                                    <InputGroupAddon addonType="prepend">
                                    <InputGroupText>
                                        <i className="ni ni-calendar-grid-58" />
                                    </InputGroupText>
                                    </InputGroupAddon>
                                    <ReactDatetime
                                    inputProps={{
                                        placeholder: "Hingga tanggal"
                                    }}
                                    range="end"
                                    timeFormat={false}
                                    value={this.state.endDate}
                                    renderDay={(props, currentDate, selectedDate) => {
                                        let classes = props.className;
                                        if (
                                        this.state.startDate &&
                                        this.state.endDate &&
                                        this.state.startDate._d + "" === currentDate._d + ""
                                        ) {
                                        classes += " start-date";
                                        } else if (
                                        this.state.startDate &&
                                        this.state.endDate &&
                                        new Date(this.state.startDate._d + "") <
                                            new Date(currentDate._d + "") &&
                                        new Date(this.state.endDate._d + "") >
                                            new Date(currentDate._d + "")
                                        ) {
                                        classes += " middle-date";
                                        } else if (
                                        this.state.endDate &&
                                        this.state.endDate._d + "" === currentDate._d + ""
                                        ) {
                                        classes += " end-date";
                                        }
                                        return (
                                        <td {...props} className={classes}>
                                            {currentDate.date()}
                                        </td>
                                        );
                                    }}
                                    onChange={(e) => this.onDateChanged(e, "endDate")}
                                    />
                                </InputGroup>
                                </FormGroup>
                            </Col>
                            <Col xs={5} className="ml-n4 mr-n4">
                                <Button
                                    color="danger"
                                    size="md"
                                    onClick={() => this.onReset()}
                                >
                                    Reset
                                </Button>
                                <Button
                                    color="primary"
                                    size="md"
                                    onClick={() => this.downloadDailyReport()}
                                >
                                    Download
                                </Button>
                            </Col>
                            <Col xs={2} className="ml-n4">
                            </Col>
                        </Row>
                      </Col>
                      <Col xs={6}>
                          
                      </Col>
                </Row>
                </CardHeader>
                <CheckoutHistories 
                  items={this.state.checkouts} 
                  toggleModal={this.toggleModal}
                  formModal={this.state.formModal}
                  formType={this.state.formType}
                  setSuccessMessage={this.setSuccessMessage}
                  setErrorMessage={this.setErrorMessage}
                  fetchData={this.fetchData.bind(this)}
                />
                <CardFooter className="py-4">
                  <nav aria-label="...">
                    <Pagination
                      className="pagination pagination-lg justify-content-end mb-0"
                      listClassName="justify-content-end mb-0"
                    >
                      <PaginationItem className={this.state.currentPage === 1 && "disabled"}>
                        <PaginationLink
                          onClick={() => this.handlePreviousPageClick()}
                          tabIndex="-1"
                        >
                          <i className="fas fa-angle-left" />
                          <span className="sr-only">Previous</span>
                        </PaginationLink>
                      </PaginationItem>
                      {renderPageNumbers}
                      <PaginationItem className={this.state.currentPage === this.state.totalPages && "disabled"}>
                        <PaginationLink
                          onClick={() => this.handleNextPageClick()}
                        >
                          <i className="fas fa-angle-right" />
                          <span className="sr-only">Next</span>
                        </PaginationLink>
                      </PaginationItem>
                    </Pagination>
                  </nav>
                </CardFooter>
              </Card>
            </div>
          </Row>
        </Container>
      </>
    );
  }
}

export default CheckoutHistory;
